<template>
  <div id="content">
    <div class="basicInformation">
      <div class="typeArea">
        <h2 class="title">联系人信息</h2>
        <el-form label-position="left" :model="contactInfo" :rules="rules">
          <el-form-item label="联系人姓名" style="display: block" prop="contactName">
            <el-col :span="24">
              <el-input
                v-model="contactInfo.contactName"
                :placeholder="`请输入联系人姓名`"
                style="position: relative;"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="`联系人电话`" prop="contactTel">
            <el-col :span="24">
              <el-input v-model="contactInfo.contactTel" :placeholder="`请输入联系人电话`" :maxlength="11"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="`联系人邮箱`" prop="contactEml">
            <el-col :span="24">
              <el-input v-model="contactInfo.contactEml" :placeholder="`请输入联系人邮箱`"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="`联系人地址`" prop="contactAddr">
            <el-col :span="24">
              <el-input v-model="contactInfo.contactAddr" :placeholder="`请输入联系人地址`"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <div class="matter">
        <el-button @click="changePFcontactInfo" style="width: 165px; text-align: center;">下一步</el-button>
        <el-button
          @click="$router.go(-1)"
          style="background: #FFF; color: #FF6A01; border: 1px solid #FF6A01;"
        >上一步</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      labelPosition: "right",
      contactInfo: {
        contactName: "",
        contactTel: "",
        contactEml: "",
        contactAddr: "",
      },
      rules: {
        contactName: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
          {
            required: true,
            pattern: /^[\u2E80-\u9FFF]+$/,
            message: "请输入姓名的正确格式",
            trigger: "blur",
          },
        ],
        contactTel: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入电话的正确格式",
            trigger: "blur",
          },
        ],
        contactEml: [
          { required: true, message: "请输入联系人邮箱", trigger: "blur" },
          {
            required: true,
            pattern: /^\w+@[a-z0-9]+\.[a-z]{2,4}$/,
            message: "请输入邮箱正确格式",
            trigger: "blur",
          },
        ],
        contactAddr: [
          { required: true, message: "请输入联系人地址", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      PFcontactInfo: (state) => state.brandReview.PFcontactInfo,
    }),
  },
  mounted() {
    this.$store.commit("qffillmaterials/changeActivedIndex", 1);
  },
  methods: {
    changePFcontactInfo() {
      if (
        this.contactInfo.contactName &&
        this.contactInfo.contactTel &&
        this.contactInfo.contactEml &&
        this.contactInfo.contactAddr !== ""
      ) {
        this.$router.push("/brandReview/professional/PFagentInformation"),
          this.$store.commit(
            "brandReview/changePFcontactInfo",
            this.contactInfo
          );
      } else {
        this.$message({ message: "请补全页面中的条件", type: "warning" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#content {
  width: 100%;
  padding-bottom: 10px;
  overflow: hidden;
  background-color: #f4f4f4;
  .basicInformation {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    background-color: #fff;
    border: 1px solid #ddd;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    padding-bottom: 50px;
    .typeArea {
      width: 80%;
      .title {
        white-space: nowrap;
        font-size: 18px;
        font-weight: 900;
        height: 100%;
        margin-top: 30px;
      }
      .el-form {
        margin-top: 20px;
        margin-left: 20px;
        /deep/.el-form-item {
          display: inline-block;
          white-space: nowrap;
          width: 100%;
          margin-bottom: 12px;
          .el-form-item__error {
            margin-top: 45px;
          }
          .el-form-item__label {
            margin-right: 40px;
          }
          .el-form-item__content {
            height: 30px;
            width: 60%;
            .el-input {
              display: inline-block;
              width: 100%;
              height: 35px;
              .el-input__inner {
                border-radius: 0px;
                display: inline-block;
                width: 100%;
                height: 35px;
              }
            }
          }
        }
      }
    }
  }
  .footer {
    position: relative;
    bottom: -10px;
    width: 100%;
    height: 100px;
    background-color: #fff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .matter {
      position: absolute;
      right: 190px;
      bottom: 22px;
      display: flex;
      align-items: center;
      .num {
        display: inline-block;
        i {
          color: #ff6a01;
        }
        .price {
          font-size: 28px;
          font-weight: 900;
          color: #ff6a01;
        }
      }
      .el-button {
        background-color: #ff6a01;
        font-size: 16px;
        width: 145px;
        height: 44px;
        color: #fff;
        margin-left: 30px;
        border-radius: 0px;
      }
    }
  }
}
</style>